// Skizze auf der Rechenseite (C7): welche Ansicht, welcher Zustand der
// Skizzenfläche. Reine Funktionen, damit UI und Tests dieselbe Regel nutzen.

export const SKETCH_VIEWS = ['kette', 'skizze', 'beides'];

/** Wert aus profiles.sketch_view; leer oder ungültig heißt „beides“. */
export function viewFromProfile(value) {
  return SKETCH_VIEWS.includes(value) ? value : 'beides';
}

/** Die Tour braucht die Maßkette sichtbar. */
export function effectiveView(view, { tourAktiv }) {
  return tourAktiv && view === 'skizze' ? 'beides' : view;
}

/**
 * slot: 'bild' (Skizze da), 'leer' (Pro kann hinzufügen), 'pro'
 * (Free-Hinweis), 'projekt' (Berechnung noch nicht im Projekt).
 * Ändern nur Pro mit gespeicherter Berechnung und ohne Versions-Vorschau;
 * die PATCH-Route ist Pro-only, deshalb kann Free auch nicht entfernen.
 */
export function sketchSlot({ sketchUrl, isPro, hasCalc, preview }) {
  const canAdd = !!(isPro && hasCalc && !preview);
  if (sketchUrl) return { slot: 'bild', canAdd, canRemove: canAdd };
  if (!hasCalc) return { slot: 'projekt', canAdd: false, canRemove: false };
  if (!isPro) return { slot: 'pro', canAdd: false, canRemove: false };
  return { slot: 'leer', canAdd, canRemove: false };
}
